// extracted by mini-css-extract-plugin
export default {"container":"AJ-z","topReviewHeading":"BJ-z","criticalReview":"CJ-z","favorableReview":"DJ-z","vsSeparator":"EJ-z"};